import { inject, observer } from "mobx-react";
import React from "react";
import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";
import { compose } from "recompose";

import { ReactComponent as LogoutIcon } from "nvent-web/assets/svg/side-menu/logout.svg";
import { Auth0 } from "nvent-web/services/Auth0";

import style from "./SidebarMenu.module.scss";

interface SidebarMenuInnerProps extends InjectedIntlProps {
  auth0: Auth0;
}

class SidebarMenuInner extends React.Component<SidebarMenuInnerProps, {}> {
  render() {
    return (
      <nav className={style.menu}>
        {this.props.children}
        {this.renderLogOutItem()}
      </nav>
    );
  }

  private renderLogOutItem() {
    return (
      <button type="button" className={style.logoutItem} onClick={this.logOut}>
        <div className={style.simpleItem}>
          <div className={style.itemIcon}>
            <LogoutIcon />
          </div>
          <div className={style.itemText}>
            <FormattedMessage id="side.menu.logOut" />
          </div>
        </div>
      </button>
    );
  }

  private logOut = () => {
    this.props.auth0.logout();
  };
}

export const SidebarMenu = compose<SidebarMenuInnerProps, {}>(
  injectIntl,
  inject("auth0"),
  observer
)(SidebarMenuInner);

export default SidebarMenu;
